"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var StepState = /** @class */ (function () {
    function StepState(name, config) {
        this.required = true;
        this.completed = false;
        this.name = name,
            this.stepConfig = config;
    }
    return StepState;
}());
exports.StepState = StepState;
var WizardState = /** @class */ (function () {
    function WizardState(steps) {
        this.steps = lodash_1.map(steps, (function (value) {
            return new StepState(value.name, value);
        }));
        this.stepInfo = steps;
    }
    return WizardState;
}());
exports.WizardState = WizardState;
//# sourceMappingURL=state.js.map